
export function formatMsDuration(ms: number | null) {

  const milliseconds = ms ? ms : 0;
  const minutesPerDay = 60 * 24;

  let seconds = Math.floor(milliseconds / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  let days = Math.floor(minutes / minutesPerDay);

  seconds = seconds % 60;
  minutes = minutes % 60;
  hours = hours % 24;
  days = days % minutesPerDay;

  return `${days > 0 ? days + 'd ' : ''}${hours > 0 ? hours + 'h ' : ''}${minutes}m ${seconds}s`;
}

export function formatNumber(n: number | undefined) {
  if (!n) {
    return 0;
  }

  if (n === 0) {
    return '00'
  }

  return n.toString().length < 2
    ? '0' + n
    : n;
}

export function formatPlural(list: any[], textOne: string, textMany?: string) {
  if (!textMany) {
    return textOne;
  }

  return list && list.length > 1 ? textMany : textOne;
}

export function getWinrateString(games: number | null, wins: number | undefined) {
  const zero = '0%';

  if (!games || !wins) {
      return zero;
  }

  if (games === 0) {
      return zero;
  }
  const winrate = (wins / games) * 100;
  return (isNaN(winrate)) ? zero : winrate.toString().slice(0, 5) + '%';
}

export function getAverageFromList(list: number[]) {
  if (!list || !list.length) {
    return 0;
  }

  const sum = list.reduce((a, b) => a + b, 0);
  return (sum / list.length) || 0;
}


export function shortText(text: string, symbols: number = 4) {
  if (!text) {
    return '';
  }
  return text.substring(0, symbols);
}